/**
 * Коди `401` веб-сесії — копія `@clientline/contracts` (`auth-problems.ts`): значень з кореня
 * контрактів перший екран не імпортує (zod), збіг тримає тест `auth-codes.test.ts`.
 * `session_expired` — природний сплив сесії: лише на нього застосунок показує повторний вхід
 * поверх сторінки (E3a-06b). Будь-який інший код 401 — `unauthenticated` (fail closed).
 */
export const SESSION_EXPIRED_CODE = 'session_expired';
